module.exports = __webpack_public_path__ + "static/media/reedIJTaki1028.56e09339.ico";